var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleNavLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_127)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 21,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 21,
    r: 20.5,
    stroke: "#F5F5F5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5424 12.6163C28.4408 12.5144 28.3201 12.4336 28.1873 12.3784C28.0544 12.3233 27.9119 12.2949 27.7681 12.2949C27.6242 12.2949 27.4817 12.3233 27.3489 12.3784C27.216 12.4336 27.0953 12.5144 26.9937 12.6163L19.7224 19.8875C19.6413 19.9685 19.577 20.0646 19.5331 20.1705C19.4892 20.2763 19.4666 20.3898 19.4666 20.5044C19.4666 20.619 19.4892 20.7324 19.5331 20.8383C19.577 20.9441 19.6413 21.0403 19.7224 21.1213L26.9937 28.3925C27.4224 28.8213 28.1137 28.8213 28.5424 28.3925C28.9712 27.9638 28.9712 27.2725 28.5424 26.8438L22.2074 20.5L28.5512 14.1563C28.9712 13.7363 28.9712 13.0363 28.5424 12.6163Z",
    fill: "#565656"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_127",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_127",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleNavLeft);
export default __webpack_public_path__ + "static/media/circle-nav-left.ce6994fdd5067dc5b767eda17dd5cee5.svg";
export { ForwardRef as ReactComponent };